import { render, staticRenderFns } from "./createFornecedor.vue?vue&type=template&id=172b11d0&scoped=true&"
import script from "./createFornecedor.vue?vue&type=script&lang=js&"
export * from "./createFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./createFornecedor.vue?vue&type=style&index=0&id=172b11d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b11d0",
  null
  
)

export default component.exports